import Header from '../common/Header';
import Footer from '../common/Footer';
import { useEffect } from 'react';
import SeoHelmet from '../common/SeoHelmet';
const Disclaimer = () => {
  return (
    <>
      <SeoHelmet
        title="GeoCalc | Disclaimer"
        description="Legal disclaimer for GeoCalc.app, covering information accuracy, external links, consent, and updates."
        url="https://www.geocalc.app/disclaimer"
        image="https://www.geocalc.app/assets/og-theory-v1.jpg"
        schemaType="page"
        breadcrumbs={[
          { name: 'Home', url: 'https://www.geocalc.app/' },
          { name: 'Disclaimer', url: 'https://www.geocalc.app/disclaimer' },
        ]}
      />

      <Header />
      <div className="privacyPolicy">
        <h1>Disclaimer</h1>
        <p>
          <strong>Use at your own risk.</strong> The information and calculation tools on <strong>GeoCalc.app</strong> are
          provided for general information purposes only. They are <strong>not</strong> professional engineering advice and are{' '}
          <strong>not</strong> a substitute for site-specific investigations, calculations, or designs performed and checked by
          qualified professionals. Using this site does <strong>not</strong> create an engineer-of-record or client relationship
          with GeoCalc.
        </p>

        <h2>Calculations and assumptions</h2>
        <p>
          Tool outputs depend on user-supplied inputs and simplifying assumptions. Results may be approximate, incomplete, or
          incorrect. You are responsible for independently verifying all results and for ensuring compliance with applicable
          codes, standards, and regulatory requirements.
        </p>

        <h2>No warranties</h2>
        <p>
          The site and all content are provided <strong>“as is” and “as available”</strong>, without warranties of any kind,
          express or implied, including implied warranties of merchantability, fitness for a particular purpose, and
          non-infringement.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          <strong>To the fullest extent permitted by applicable law</strong>, GeoCalc will not be liable for any indirect,
          incidental, special, consequential, exemplary, or punitive damages, or for any loss of profits, revenue, data, goodwill,
          or business interruption, in each case arising out of or relating to the site or tools, <strong>even if</strong> advised
          of the possibility of such damages. Except for liabilities that cannot be limited by law, GeoCalc’s{' '}
          <strong>aggregate</strong> liability for all claims arising out of or relating to the site or tools will not exceed the
          total amounts you paid (if any) to use the service in the <strong>twelve (12) months</strong> before the event giving
          rise to the liability (or <strong>$0</strong> for free services). These limits apply <strong>whether</strong> the claim
          is based on warranty, contract, tort (including negligence), strict liability, or any other legal theory. Nothing in
          this section limits liability for <strong>fraud</strong>, <strong>willful misconduct</strong>, or{' '}
          <strong>death/personal injury</strong> to the extent that such limitation is prohibited by law. Your statutory rights
          may vary depending on your jurisdiction.
        </p>

        <h2>External links</h2>
        <p>
          This site may link to third-party websites. GeoCalc does not control and is not responsible for their content or
          practices. Follow external links at your own risk.
        </p>

        <h2>Availability and changes</h2>
        <p>
          The site or any feature may be modified, suspended, or discontinued at any time without notice. Content may be updated
          and may include errors or omissions.
        </p>

        <h2>Changes to this disclaimer</h2>
        <p>We may update this page from time to time. Material changes will be reflected by updating the date above.</p>
        <h2>Contact</h2>
        <p>
          Questions about this disclaimer: <a href="mailto:info@geocalc.app">info@geocalc.app</a>.
        </p>
        <p>
          <em>Last updated: 15/Otober/2025</em>
        </p>
      </div>

      <Footer />
    </>
  );
};

export default Disclaimer;
